import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { IRNStatusRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/IRNStatusRenderer';
import { Utilities } from 'src/app/models/utilities';
import { JobService } from 'src/app/services/job.service';
import { ImportErrorComponent } from '../import-error/importerror.component';
import { AppCoreService } from 'src/app/services/app-core.service';
import { ExcelService } from 'src/app/services/excel.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-jobs-validation',
  templateUrl: './jobs-validation.component.html',
  styleUrls: ['./jobs-validation.component.scss']
})
export class JobsValidationComponent {
  @Input() public jobGuid: any;
  @Input() public jobCategory: any;
  recordStatusObj = { totalRecord: 0, validRecord: 0, invalidRecord: 0 };

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120,
  };

  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight',
  }

  columnDefs = [];
  rowData = [];

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private excelService: ExcelService,
    private ngxLoaderService: NgxUiLoaderService,
    private appCoreService: AppCoreService,
    private jobService: JobService,
  ) {
    this.context = { componentParent: this }
  }

  ngOnInit() {
    this.setColumnDefs();
    this.bindList();
  }

  setColumnDefs() {
    if (this.jobCategory === 'CHARGES') {
      this.columnDefs = [
        { headerName: 'Sr No', valueGetter: 'node.rowIndex + 1', pinned: 'left', minWidth: 80 },
        { headerName: 'Charge', field: 'chargename', filter: true, minWidth: 150 },
        { headerName: 'Product', field: 'productcode', filter: true },
        { headerName: 'Vendor', field: 'vendorcode', filter: true },
        { headerName: 'Service', field: 'servicename', filter: true },
        { headerName: 'Origin Country', field: 'origincountrycode', filter: true },
        { headerName: 'Origin State', field: 'originstatecode', filter: true },
        { headerName: 'Origin City', field: 'origincitycode', filter: true },
        { headerName: 'Origin Pincode', field: 'originpincode', filter: true },
        { headerName: 'Destination Country', field: 'destinationcountrycode', filter: true },
        { headerName: 'Destination State', field: 'destinationstatecode', filter: true },
        { headerName: 'Destination City', field: 'destinationcitycode', filter: true },
        { headerName: 'Destination Pincode', field: 'destinationpincode', filter: true },
        {
          headerName: 'Status',
          field: 'isvalid',
          colId: 'params',
          filter: false,
          sortable: true,
          pinned: 'right',
          minWidth: 70,
          cellRenderer: IRNStatusRenderer
        },
      ];
    } else if (this.jobCategory === 'ODA') {
      this.columnDefs = [
        { headerName: 'Sr No', valueGetter: 'node.rowIndex + 1', pinned: 'left', maxWidth: 120 },
        { headerName: 'Vendor', field: 'vendorcode', filter: true },
        { headerName: 'Service', field: 'servicename', filter: true },
        { headerName: 'Destination Country', field: 'destinationcountrycode', filter: true },
        { headerName: 'Destination State', field: 'destinationstatecode', filter: true },
        { headerName: 'Destination City', field: 'destinationcitycode', filter: true },
        { headerName: 'Pincode', field: 'destinationpincode', filter: true },
        {
          headerName: 'ODA',
          field: 'oda',
          cellRenderer: (params: { value: boolean; }) => {
            let statusHtml = '<span class="badge bg-dark">No</span>';
            if (params.value) {
              statusHtml = '<span class="badge bg-success">Yes</span>';
            }
            return statusHtml;
          }
        },
        {
          headerName: 'Serviceable',
          field: 'serviceable',
          cellRenderer: (params: { value: boolean; }) => {
            let statusHtml = '<span class="badge bg-dark">No</span>';
            if (params.value) {
              statusHtml = '<span class="badge bg-success">Yes</span>';
            }
            return statusHtml;
          }
        },
        {
          headerName: 'Status',
          field: 'isvalid',
          colId: 'params',
          filter: false,
          sortable: true,
          pinned: 'right',
          maxWidth: 150,
          cellRenderer: IRNStatusRenderer
        },
      ];
    } else if (this.jobCategory === 'PINCODES') {
      this.columnDefs = [
        { headerName: 'Sr No', valueGetter: 'node.rowIndex + 1', pinned: 'left', maxWidth: 120 },
        { headerName: 'City', field: 'city', filter: true },
        { headerName: 'Pincode From', field: 'pincodefrom', filter: true },
        { headerName: 'Pincode To', field: 'pincodeto', filter: true },
        {
          headerName: 'Status',
          field: 'isvalid',
          colId: 'params',
          filter: false,
          sortable: true,
          pinned: 'right',
          maxWidth: 150,
          cellRenderer: IRNStatusRenderer
        },
      ];
    } else {
      // Default Columns
      this.columnDefs = [
        // { headerName: 'Sr No', valueGetter: 'node.rowIndex + 1', pinned: 'left', maxWidth: 120 },
        { headerName: 'AWB No', field: 'awbno', pinned: 'left', maxWidth: 150 },
        { headerName: 'Reference No', field: 'refno', maxWidth: 150 },
        { headerName: 'Customer Code', field: 'customercode', maxWidth: 150 },
        { headerName: 'Company Code', field: 'companycode', maxWidth: 150 },
        { headerName: 'Booking Date', field: 'bookingdate', maxWidth: 150 },
        { headerName: 'Product Code', field: 'product', maxWidth: 150 },
        { headerName: 'Vendor Code', field: 'vendorcode', maxWidth: 150 },
        { headerName: 'Service Name', field: 'servicename', maxWidth: 150 },
        { headerName: 'Shipment Value', field: 'shipmentvalue', maxWidth: 150 },

        { headerName: 'Shipper Name', field: 'shippername', maxWidth: 150 },
        { headerName: 'Shipment Contact', field: 'shippercontact', maxWidth: 150 },
        { headerName: 'Shipper Email', field: 'shipperemail', maxWidth: 150 },
        { headerName: 'Shipper Address1', field: 'shipperadd1', maxWidth: 150 },
        { headerName: 'Shipper Address2', field: 'shipperadd2', maxWidth: 150 },
        { headerName: 'Shipper Pincode', field: 'shipperpin', maxWidth: 150 },
        { headerName: 'Shipper MobileNo', field: 'shippermobileno', maxWidth: 150 },
        { headerName: 'Shipper TelNo', field: 'shippertelno', maxWidth: 150 },
        { headerName: 'Shipper Area', field: 'shipperarea', maxWidth: 150 },
        { headerName: 'Shipper DocumentType', field: 'shipperdocumenttype', maxWidth: 150 },
        { headerName: 'Shipper DocumentNo', field: 'shipperdocumentno', maxWidth: 150 },
        { headerName: 'Origin Country Code', field: 'origincountry', maxWidth: 150 },
        { headerName: 'Origin State Code', field: 'originstate', maxWidth: 150 },
        { headerName: 'Origin City Code', field: 'origincity', maxWidth: 150 },

        { headerName: 'Consignee Name', field: 'consigneename', maxWidth: 150 },
        { headerName: 'Consignee Contact', field: 'consigneecontact', maxWidth: 150 },
        { headerName: 'Consignee Email', field: 'consigneeemail', maxWidth: 150 },
        { headerName: 'Consignee Address1', field: 'consigneeadd1', maxWidth: 150 },
        { headerName: 'Consignee Address2', field: 'consigneeadd2', maxWidth: 150 },
        { headerName: 'Consignee Pincode', field: 'consigneepin', maxWidth: 150 },
        { headerName: 'Consignee MobileNo', field: 'consigneemobileno', maxWidth: 150 },
        { headerName: 'Consignee TelNo', field: 'consigneetelno', maxWidth: 150 },
        { headerName: 'Consignee Area', field: 'consigneearea', maxWidth: 150 },
        { headerName: 'Destination Country Code', field: 'destinationcountry', maxWidth: 150 },
        { headerName: 'Destination State Code', field: 'destinationstate', maxWidth: 150 },
        { headerName: 'Destination City Code', field: 'destinationcity', maxWidth: 150 },

        { headerName: 'Total Pieces', field: 'pcs', maxWidth: 150 },
        { headerName: 'Actual Weight', field: 'weight', maxWidth: 150 },
        { headerName: 'Volumetric Weight', field: 'volumetricweight', maxWidth: 150 },
        { headerName: 'Weight Unit', field: 'unit', maxWidth: 150 },

        { headerName: 'Delivery Awb No', field: 'deliveryawbno', maxWidth: 150 },
        { headerName: 'Forwarding Awb No', field: 'forwardingawbno', maxWidth: 150 },
        { headerName: 'Delivery Product', field: 'deliveryproduct', maxWidth: 150 },
        { headerName: 'Delivery Vendor', field: 'deliveryvendor', maxWidth: 150 },
        { headerName: 'Delivery Service', field: 'deliveryservice', maxWidth: 150 },
        { headerName: 'Vendor Weight', field: 'vendorweight', maxWidth: 150 },

        { headerName: 'Master Awb No', field: 'masterawbno', maxWidth: 150 },
        { headerName: 'Excepted Delivery Date', field: 'expecteddelvdate', maxWidth: 150 },

        { headerName: 'Invoice No', field: 'invoiceno', maxWidth: 150 },
        { headerName: 'Invoice Date', field: 'invoicedate', maxWidth: 150 },
        { headerName: 'Delivery Date', field: 'deliverydate', maxWidth: 150 },
        { headerName: 'Delivery Time', field: 'deliverytime', maxWidth: 150 },

        { headerName: 'Receiver Name', field: 'receiver', maxWidth: 150 },
        { headerName: 'Receiver TelNo', field: 'recicevertel', maxWidth: 150 },
        { headerName: 'Remark', field: 'remark', maxWidth: 150 },

        { headerName: 'Transaction Status', field: 'transactionStatus', maxWidth: 150, cellRenderer: Utilities?.status },
        {
          headerName: 'Status',
          field: 'isvalid',
          colId: 'params',
          filter: false,
          sortable: true,
          pinned: 'right',
          maxWidth: 150,
          cellRenderer: IRNStatusRenderer
        },
      ];
    }
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  bindList() {
    try {
      this.ngxLoaderService.start();
      this.jobService.GetByGuid(this.jobGuid).subscribe(res => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          const data = res.data[0];
          this.rowData = data.validationresult
          // console.log("RES>DATA",data);
          this.updateRecordStatus(data);
        } else {
          this.ngxLoaderService.stop();
        }
      })
    }
    catch (err) {
      this.ngxLoaderService.stop();
      console.error(err);
    }
  }

  updateRecordStatus(data: any) {
    this.recordStatusObj.totalRecord = data.totalrecords;
    this.recordStatusObj.invalidRecord = data.failedrecords;
    this.recordStatusObj.validRecord = Number(data.totalrecords) - Number(data.failedrecords);
  }


  errorAction(data: any) {
    // console.log("data",data)
    try {
      if (data) {
        let ngbModalOptions: NgbModalOptions = {
          ariaLabelledBy: 'modal-basic-title',
          size: 'md',
          backdrop: 'static',
          keyboard: false,
          centered: true
        };
        const modalRef = this.modalService.open(ImportErrorComponent, ngbModalOptions);
        modalRef.componentInstance.awbNo = data.awbno;
        modalRef.componentInstance.srNo = data.srno;
        modalRef.componentInstance.cellData = data.errors;
      }
    } catch (err) {
      console.error('Error', err);
    }
  }

  async warningDialog(msg: any, data: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    const confirmText = isHtml ? '<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      confirmButtonText: confirmText,
      showCloseButton: true,
      showConfirmButton: isHtml,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (res.isConfirmed) {
      this.excelService.exportAsExcelFile(data, "AWB_Import");
    }
  }


}